import { useContext, useState } from "react";
import { AppContext } from "../../../context/appContext";
import { Avatar, Box, IconButton, Stack, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { TopNavigationWrapper } from "./styled";
import { TopNavigationNotificationIcon } from "../../../assets";
import { ArrowForwardIos } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import { BaseDropDownType } from "../../../types/component.type";
import { NavigationPropsType } from "../../../types/container.type";
import { BaseDropDown } from "../../../components/modal/dropdown";
import { useNavigate } from "react-router-dom";

export const TopNavigation: React.FC<NavigationPropsType> = ({ pageTitle, username, role, headshot, handleLogOutUser }) => {
    const userMenuItems = [
        {
            title: "Change Password",
            url: "/passwordreset",
        },
        {
            title: "Settings",
            url: "/profile",
        },
        {
            title: "Log Out",
            url: "/logout",
        }
    ];

    const {
        isSideNavigationClosing,
        isMobileSideNavigationOpen,
        setIsMobileSideNavigationOpen
    } = useContext(AppContext);
    const navigate = useNavigate();
    const matches = useMediaQuery('(min-width:768px)');

    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

    const handleDrawerToggle = () => {
        if (!isSideNavigationClosing) {
            setIsMobileSideNavigationOpen(!isMobileSideNavigationOpen);
        }
    };

    const handleUserMenuClick = () => {
        return setIsUserMenuOpen(true);
    };

    const handleUserMenuClose = () => {
        return setIsUserMenuOpen(false);
    };

    const handleUserMenuItemClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item: BaseDropDownType) => {
        e.preventDefault();
        switch (item.title) {
            case "Change Password":
            case "Settings":
                navigate(item.url);
                setIsUserMenuOpen(false);
                break;
            case "Log Out":
                handleLogOutUser();
                setIsUserMenuOpen(false);
                break;
            default:
                break;
        }
    };

    return (
        <TopNavigationWrapper>
            <Toolbar>
                <BaseDropDown
                    open={(matches && isUserMenuOpen)}
                    className="top-navigation-user-menu-dropdown user-menu-dropdown"
                    handleClose={handleUserMenuClose}
                    items={userMenuItems}
                    handleItemClick={handleUserMenuItemClick}
                />
                <Box
                    component={"div"}
                    className="top-navigation-LHS"
                >
                    <Typography
                        variant="h1"
                        fontFamily={"Poppins"}
                        fontWeight={600}
                        fontSize={32}
                        lineHeight={"normal"}
                        color="var(--light-color)"
                    >
                        {pageTitle}
                    </Typography>
                </Box>
                <Stack
                    className="top-navigation-RHS"
                    direction={"row"}
                    gap={"calc(var(--flex-gap)/4)"}
                    onClick={handleUserMenuClick}
                >
                    <Box
                        component={"div"}
                        className="top-navigation-RHS-item notification-icon-area"
                    >
                        <IconButton
                            sx={{ padding: 0 }}
                        >
                            <TopNavigationNotificationIcon />
                        </IconButton>
                    </Box>
                    <Stack
                        className="top-navigation-RHS-item user-profile-icon-area"
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        gap={"calc(var(--flex-gap)/4)"}
                    >
                        <Avatar
                            variant="rounded"
                            // replace below with username for fallback
                            // also include a fallback icon path in src
                            // that means include src too
                            alt="Test User"
                            sx={{
                                bgcolor: "transparent",
                                width: "unset",
                                height: "unset",
                                maxWidth: "40px",
                                maxHeight: "40px"
                            }}
                        >
                            {headshot}
                        </Avatar>
                        <Box>
                            <Typography
                                variant="subtitle1"
                                fontFamily={"Poppins"}
                                fontWeight={500}
                                fontSize={14}
                                lineHeight={"normal"}
                                color="var(--light-color)"
                                maxWidth={"4.0625rem"}
                            >
                                {username}
                            </Typography>
                        </Box>
                        <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={"calc(var(--flex-gap)/4)"}
                            overflow={"hidden"}
                        >
                            <Box
                                component={"div"}
                                className="role-box"
                            >
                                <Typography
                                    variant="subtitle1"
                                    fontFamily={"Inter"}
                                    fontWeight={400}
                                    fontSize={14}
                                    lineHeight={"normal"}
                                    maxWidth={"2.6765625rem"}
                                    sx={{
                                        background: "linear-gradient(92deg, #0058FA 1.48%, #0058FA 92.76%)",
                                        backgroundClip: "text",
                                        textFillColor: "transparent",
                                    }}
                                >
                                    {role}
                                </Typography>
                            </Box>
                            <IconButton
                                sx={{ padding: 0 }}
                            >
                                <ArrowForwardIos sx={{ color: "var(--light-color)", transform: "rotate(90deg)" }} />
                            </IconButton>
                        </Stack>
                    </Stack>
                    <Box
                        component={"div"}
                        className="top-navigation-RHS-item menu-button-box"
                    >
                        <IconButton
                            size="large"
                            color="inherit"
                            aria-label="menu"
                            sx={{
                                color: "var(--light-color)",
                                padding: 0
                            }}
                            onClick={handleDrawerToggle}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Stack>
            </Toolbar>
        </TopNavigationWrapper >
    )
}
